module.exports = __webpack_public_path__ + "static/media/cifar8.bfcd5763.png";